import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import {
  FRONT_APP_CONTACT_URL,
  FRONT_APP_PRIVACY_URL,
  FRONT_APP_TERMS_URL,
  FRONT_APP_URL,
  SITE_NAME
} from "../../../../_emywork/helpers/UIHelper";
import {Link} from "react-router-dom";
import {useIntl} from "react-intl";
import {LanguageSelectorDropdown} from "../extras/dropdowns/LanguageSelectorDropdown";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();
  const {formatMessage} = useIntl()

  const layoutProps = useMemo(() => {
    return {
      footerLayout: objectPath.get(uiService.config, "footer.layout"),
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true),
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Footer */}
      {/* doc: add "bg-white" class to have footer with solod background color */}
      <div
        className={`footer py-4 d-flex flex-lg-column ${layoutProps.footerClasses}`}
        id="kt_footer"
      >
        {/*<div className="d-flex flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">*/}
        {/*  <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2 text-dark-50 font-size-lg font-weight-bolder mr-10">*/}
        {/*    &copy; 2020 {SITE_NAME}*/}
        {/*  </div>*/}
        {/*  <div className="d-flex order-1 order-sm-2 my-2">*/}
        {/*    <Link to="/emy_projects" className="text-primary font-weight-bolder font-size-lg">*/}
        {/*      {formatMessage({id:"HOME"})}*/}
        {/*    </Link>*/}
        {/*    <a*/}
        {/*      href="#"*/}
        {/*      className="text-primary font-weight-bolder font-size-lg ml-4"*/}
        {/*    >*/}
        {/*      {formatMessage({id:"PRIVACY"})}*/}
        {/*    </a>*/}
        {/*    <a*/}
        {/*      href="#"*/}
        {/*      className="text-primary font-weight-bolder font-size-lg ml-4"*/}
        {/*    >*/}
        {/*      {formatMessage({id:"TERMS"})}*/}
        {/*    </a>*/}
        {/*    <a*/}
        {/*      href={'#'}*/}
        {/*      className="text-primary font-weight-bolder font-size-lg ml-4"*/}
        {/*    >*/}
        {/*      {formatMessage({id:"CONTACT"})}*/}
        {/*    </a>*/}
        {/*  </div>*/}
        {/*</div>*/}

        {/* begin::Container */}
        <div
          className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
        >
          {/* begin::Copyright */}
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold mr-">
              {today} &copy;
            </span>
            {` `}
            <a
              href="/"
              rel="noopener noreferrer"
              target="_blank"
              className="text-dark-75 text-hover-primary"
            >
              {SITE_NAME}
            </a>
          </div>
          {/* end::Copyright */}
          {` `}
          {/* begin::Nav */}
          <div className="nav nav-dark order-1 order-md-2">
            <LanguageSelectorDropdown />
            {
              [
                {id: 'HOME', url: FRONT_APP_URL},
                {id: 'PRIVACY', url: FRONT_APP_PRIVACY_URL},
                {id: 'TERMS', url: FRONT_APP_TERMS_URL},
                {id: 'CONTACT', url: FRONT_APP_CONTACT_URL},
              ].map(row=>(
                <a
                  key={row.id}
                  href={row.url}
                  className="nav-link px-3"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {formatMessage({id:row.id})}
                </a>
              ))
            }
          </div>
          {/* end::Nav */}
        </div>
        {/* end::Container */}
      </div>
      {/* end::Footer */}
    </>
  );
}
